import { render, staticRenderFns } from "./imgtext-detail.vue?vue&type=template&id=44e1a79f&scoped=true"
import script from "./imgtext-detail.vue?vue&type=script&lang=js"
export * from "./imgtext-detail.vue?vue&type=script&lang=js"
import style0 from "./imgtext-detail.vue?vue&type=style&index=0&id=44e1a79f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1a79f",
  null
  
)

export default component.exports